import React, { useEffect } from "react";
import { storageApi } from "../storage/storageApi";
import { appRoutes, useAppNavigation } from "../router/routes";

const GuardLayout = ({ children }) => {
  const isUserLogin = storageApi.useIsUserLogin();
  const { isUserForceUpdateProfile } = storageApi.useGetUser();

  const { navigate } = useAppNavigation();

  useEffect(() => {
    if (!isUserLogin || isUserForceUpdateProfile) {
      navigate(appRoutes.authLogin);
    }
  }, [isUserLogin, isUserForceUpdateProfile]);

  return <div>{children}</div>;
};

export default GuardLayout;
